import { render, staticRenderFns } from "./BlockHero.vue?vue&type=template&id=423cc707&scoped=true&lang=pug&"
import script from "./BlockHero.vue?vue&type=script&lang=ts&"
export * from "./BlockHero.vue?vue&type=script&lang=ts&"
import style0 from "./BlockHero.vue?vue&type=style&index=0&id=423cc707&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cc707",
  null
  
)

export default component.exports